// src/pages/repair&restore.js
import React from "react";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet";
import { businessSchemaDE, businessSchemaEN } from "../schema";
import RepairAndRestore from "../components/repair&restore/repair&restore";

// Import page-level translations
import repairEnTranslations from "../translations/repair_en.json";
import repairDeTranslations from "../translations/repair_de.json";

const RepairAndRestorePage = () => {
  const { t, i18n } = useTranslation();

  // Add translations for this page
  i18n.addResourceBundle("en", "repairPage", repairEnTranslations, true, true);
  i18n.addResourceBundle("de", "repairPage", repairDeTranslations, true, true);

  const currentSchema =
    i18n.language === "en" ? businessSchemaEN : businessSchemaDE;

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(currentSchema)}
        </script>
        <title>{t("repairPage:page_title")}</title>
        <meta name="description" content={t("repairPage:meta_description")} />
        <meta name="keywords" content={t("repairPage:meta_keywords")} />
        <meta property="og:title" content={t("repairPage:page_title")} />
        <meta
          property="og:description"
          content={t("repairPage:meta_description")}
        />
      </Helmet>
      <div>
        <RepairAndRestore />
      </div>
    </>
  );
};

export default RepairAndRestorePage;
